import { SEOHead } from "@/components/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotArticlesCarousel from "./components/HotArticlesCarousel";
import LatestArticlesGrid from "./components/LatestArticlesGrid";
import TrendingSection from "./components/TrendingSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

export default function HomePage() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "53吃瓜",
    description: "53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。",
    url: typeof window !== "undefined" ? window.location.origin : "",
    potentialAction: {
      "@type": "SearchAction",
      target: `${typeof window !== "undefined" ? window.location.origin : ""}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "53吃瓜",
    description: "53吃瓜网 - 专注娱乐八卦、明星爆料、圈内猛料追踪",
    url: typeof window !== "undefined" ? window.location.origin : "",
    logo: {
      "@type": "ImageObject",
      url: `${typeof window !== "undefined" ? window.location.origin : ""}/vite.svg`,
    },
    sameAs: ["http://ihthrnq.com/"],
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "53吃瓜-53吃瓜网站 | 53吃瓜圈内部猛料首发 | 本周娱乐八卦大事件合集",
    description: "53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。",
    url: typeof window !== "undefined" ? window.location.href : "",
    isPartOf: {
      "@type": "WebSite",
      name: "53吃瓜",
      url: typeof window !== "undefined" ? window.location.origin : "",
    },
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: "https://readdy.ai/api/search-image?query=modern%20news%20portal%20abstract%20background%2C%20dark%20elegant%20design%2C%20subtle%20red%20and%20orange%20accent%20lights%2C%20minimalist%20geometric%20shapes%2C%20premium%20quality%20feel&width=1200&height=630&seq=og-default&orientation=landscape",
    },
  };

  return (
    <>
      <SEOHead
        title="53吃瓜-53吃瓜网站 | 53吃瓜圈内部猛料首发 | 本周娱乐八卦大事件合集"
        description="53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。专注娱乐圈八卦、明星爆料、圈内猛料追踪。"
        keywords="53吃瓜,53吃瓜网,吃瓜52,53吃瓜圈,娱乐八卦,吃瓜52更新,明星爆料,圈内猛料"
        jsonLd={[websiteSchema, orgSchema, webpageSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotArticlesCarousel />
        <LatestArticlesGrid />
        <TrendingSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
